<body class="ltr main-body leftmenu">

    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <!-- <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-24 mg-b-5">
                                Registration Form </h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item active">Registration Form</li>
                            </ol>
                        </div>
                    </div> -->

                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="registrationForm">
                            <div class="col-lg-12 col-md-12">

                                <div class="card custom-card">
                                    <div class="card-body">
                                        <!-- *ngIf="submitButton" -->
                                        <!-- <div>
                                            <h3 class="main-content-label mb-1"><b>
                                                    Registration Form
                                                </b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                Registration Form
                                            </p>
                                        </div> -->
                                        
                                            <div class=" d-flex align-items-center pl-3">
                                                <img alt="Logo" src="../../assets/img/CollegeMaster.png"
                                                    class="mh-45px pb-2">
                                                <div class="ml-2">
                                                    <h3 class="main-content-label mb-1"><b>
                                                            Registration Form
                                                        </b></h3>
                                                    <p class="text-muted card-sub-title mb-0">
                                                        Registration Form </p>
                                                </div>
                                            </div>
                                        
                                        <hr class="mt-1 mb-2">
                                        <div class="row clearfix mt-3">
                                            <div class="col-sm-3">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> List No </mat-label>
                                                        <!-- <input matInput placeholder="Exam" > -->
                                                        <mat-select formControlName="EcId" #select21 class="colorblack"
                                                            required>
                                                            <mat-select-filter *ngIf="select21.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'ListDesc'"
                                                                [array]="ListOfReg"
                                                                (filteredReturn)=" filteredListOfReg =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of  filteredListOfReg"
                                                                [value]="item.CEcId" (click)="selectedList(item)">
                                                                {{item.ListDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="registrationForm.controls['EcId'].touched && registrationForm.controls['EcId'].errors?.required">
                                                           Mandatory
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <input readonly matInput placeholder="">
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <input readonly matInput placeholder="New">
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline"  class="example-full-width">
                                                        <mat-label>College </mat-label>
                                                        <input formControlName="CgCodee" matInput [readonly] ="isCollege"
                                                            placeholder="College Name">
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Valid</mat-label>
                                                        <mat-select formControlName="Valid" #select104
                                                            class="colorblack">
                                                            <!-- <mat-option>Select</mat-option> -->
                                                            <mat-option value="N">No</mat-option>
                                                            <mat-option value="Y">Yes</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Changed</mat-label>
                                                        <mat-select formControlName="Chng" #select104
                                                            class="colorblack">
                                                            <!-- <mat-option>Select</mat-option> -->
                                                            <mat-option value="Y">Yes</mat-option>
                                                            <mat-option value="N">No</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <!-- <div class="col-sm-5">
                                                    <button type="button"
                                                    class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
                                                    (click)="fetchListForGridAndLoad()">New Record</button>
                                                    <button type="button"
                                                    class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
                                                    (click)="fetchListForGrid()">List</button>
                                            </div> -->
                                            <div class="row col-sm-12">
                                                <div class="col-sm-12 prpl">
                                                    <button type="button"
                                                        class="btn size1 btn-primary btn-icon-text floatright mt-1"
                                                        (click)="fetchListForGridAndLoad()">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="15vh" src="../../assets/img/save.gif"
                                                                style="margin-right: 5px;">
                                                            New
                                                        </span>
                                                    </button>
                                                    <!-- <button type="button"(click)="print()" class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="15vh" src="../../assets/img/printer.gif" style="margin-right: 7px;">
                                                            Print
                                                        </span>
                                                    </button> -->
                                                    <button type="button" (click)="fetchListForGrid()"
                                                        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="15vh" src="../../assets/img/list.gif"
                                                                style="margin-right: 7px;">
                                                            List
                                                        </span>
                                                    </button>
                                                </div>
                                            </div>
                                            
                                            <!-- <div class="row col-sm-12 mb-2">
                                                <div class="col-sm-8"></div>
                                                <div class="col-sm-2 pri-0 ">
                                                    <button type="button" (click)="fetchListForGrid()"
                                                class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1">
                                                <span style="display: contents; align-items: center;">
                                                     <img width="20vh" src="../../assets/img/list.gif" style="margin-right: 7px;">
                                                      List
                                                </span>
                                            </button>
                                               
                                                </div>
                                                <div class="col-sm-2 pri-0 mar1" >
                                                    <button type="button"
                                                    class="btn  size11 btn-primary btn-icon-text floatright mt-1"
                                                    (click)="fetchListForGridAndLoad()">
                                                    <span style="display: contents; align-items: center;">
                                                         <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                                         New Record
                                                    </span>
                                                    </button>
                                                </div>
                                               
                                               
                                                
                                            </div> -->
                                        </div>
                                        <hr class="mt-3" *ngIf="show">
                                        <div class="row clearfix" *ngIf="show">
                                            
                                            <div class="col-sm-2">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Batch</mat-label>
                                                        <input readonly matInput formControlName="Batch" placeholder="">
                                                    </mat-form-field>

                                                </div>
                                            </div>

                                            <div class="col-sm-4">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Name</mat-label>
                                                        <input matInput formControlName="Name" required placeholder="">
                                                        <mat-error class="margin_tp"
                                                            *ngIf="registrationForm.controls['Name'].touched && registrationForm.controls['Name'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Registration Number</mat-label>
                                                        <input matInput formControlName="RgNo"
                                                            placeholder="Registration Number">
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Form Number</mat-label>
                                                        <input matInput formControlName="FormNo"
                                                            placeholder="Form Number">
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> College</mat-label>
                                                        <mat-select required #select22 placeholder="College Name"
                                                            class="colorblack" formControlName="CgCode">
                                                            <mat-select-filter *ngIf="select22.focused"
                                                                [placeholder]="'College Name'"
                                                                [displayMember]="'CgName'" [array]="courseClgMapList"
                                                                (filteredReturn)="filteredstucourseClgMapListList =$event">
                                                            </mat-select-filter>
                                                            <mat-option
                                                                *ngFor="let item of filteredstucourseClgMapListList"
                                                                [value]="item.CgCode">
                                                                {{item.CgCode}} - {{item.CgName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="registrationForm.controls['CgCode'].touched && registrationForm.controls['CgCode'].errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Father Name</mat-label>
                                                        <input matInput formControlName="Father"
                                                            placeholder="Father Name">

                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Mother Name</mat-label>
                                                        <input matInput formControlName="Mother"
                                                            placeholder="Mother Name">
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Date Of Birth</mat-label>
                                                        <input required matInput [matDatepicker]="dob" id="dob"
                                                            formControlName="BirthDate"
                                                            placeholder="DD/MM/YYYY" [min]="minDate"
                                                            [max]="currentdate">
                                                        <mat-datepicker-toggle matSuffix [for]="dob">
                                                        </mat-datepicker-toggle>
                                                        <mat-datepicker #dob></mat-datepicker>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="registrationForm.controls['BirthDate'].touched && registrationForm.controls['BirthDate'].errors?.required">
                                                           Mandatory
                                                        </mat-error>
                                                    </mat-form-field>

                                                </div>
                                            </div>

                                            <div class="col-sm-3">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Gender</mat-label>
                                                        <mat-select #select23 placeholder="" class="colorblack"
                                                            formControlName="Sex">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                                [array]="genderList"
                                                                (filteredReturn)="filteredGenderList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredGenderList"
                                                                [value]="item.CdCode">
                                                                {{item.CdDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>

                                                </div>
                                            </div>

                                            <div class="col-sm-3">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Category</mat-label>
                                                        <mat-select #select24 placeholder="" class="colorblack"
                                                            formControlName="Cate">
                                                            <mat-select-filter *ngIf="select24.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                                [array]="ConstiCateList"
                                                                (filteredReturn)="filteredConstiCateList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredConstiCateList"
                                                                [value]="item.CdCode">
                                                                {{item.CdDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>

                                                </div>
                                            </div>

                                            <div class="col-sm-3">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Caste</mat-label>
                                                        <mat-select #select25 placeholder="" class="colorblack"
                                                            formControlName="Caste">
                                                            <mat-select-filter *ngIf="select25.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                                [array]="categoryList"
                                                                (filteredReturn)="filteredCategoryList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredCategoryList"
                                                                [value]="item.CdCode">
                                                                {{item.CdDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <!-- <mat-select formControlName="Caste" #select104
                                                        placeholder="Constitutional Category" class="colorblack"  >
                                                      
                                                        <mat-option  value="2">General</mat-option>
                                                        <mat-option  value="3">Schedule Caste</mat-option>
                                                        <mat-option  value="4">Schedule Tribe</mat-option>
                                                        <mat-option  value="6">VJ/DT-A</mat-option>
                                                        <mat-option  value="7">NT-B (NT-1)</mat-option>
                                                        <mat-option  value="8">NT-C (NT-2)</mat-option>
                                                        <mat-option  value="9">NT-D (NT-3)</mat-option>
                                                        <mat-option  value="1">Other Backward Class</mat-option>
                                                        <mat-option  value="5">Special Backward Class</mat-option>
                                                    </mat-select> -->
                                                    </mat-form-field>

                                                </div>
                                            </div>

                                            <div class="col-sm-3">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Email</mat-label>
                                                        <input matInput formControlName="EMail" placeholder="">

                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Medium</mat-label>
                                                        <mat-select #select26 placeholder="" class="colorblack"
                                                            formControlName="Medium">
                                                            <mat-select-filter *ngIf="select26.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                                [array]="ListOfMedium"
                                                                (filteredReturn)="filteredListOfMedium =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListOfMedium"
                                                                [value]="item.CdCode">
                                                                {{item.CdDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Nationality</mat-label>
                                                        <mat-select #select27 placeholder="" class="colorblack"
                                                            formControlName="Nation">
                                                            <mat-select-filter *ngIf="select27.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                                [array]="nationalityList"
                                                                (filteredReturn)="filteredNationalityList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredNationalityList"
                                                                [value]="item.CdCode">
                                                                {{item.CdDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Mobile</mat-label>
                                                        <input matInput formControlName="Mobile"
                                                            placeholder="">

                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> First Exam(New Student)</mat-label>
                                                        <input matTooltip="First Exam(New Student)" matInput
                                                            formControlName="EmSrNoF" placeholder="fexam">
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-select #select223 placeholder="" class="colorblack"
                                                            formControlName="EmSkip">
                                                            <mat-select-filter *ngIf="select223.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                                [array]="ListOfExamSkipReason"
                                                                (filteredReturn)="filteredListOfExamSkipReason =$event">
                                                            </mat-select-filter>
                                                            <mat-option
                                                                *ngFor="let item of filteredListOfExamSkipReason"
                                                                [value]="item.CdCode">
                                                                {{item.CdDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-3" *ngIf="Branches">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Branches</mat-label>
                                                        <mat-select #select28 placeholder="" class="colorblack"
                                                            formControlName="StrCode">
                                                            <mat-select-filter *ngIf="select28.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'StrName'"
                                                                [array]="streamList"
                                                                (filteredReturn)="filteredStreamList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredStreamList"
                                                                [value]="item.StrCode" (click)="getSub(item.StrId,item.StrCode)">
                                                                {{item.StrName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Subject Combo</mat-label>
                                                        <mat-select multiple #select29 placeholder="" class="colorblack"
                                                            formControlName="Sub">
                                                            <mat-select-filter *ngIf="select29.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EsName'"
                                                                [array]="subjectList"
                                                                (filteredReturn)="filteredSubjectList =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredSubjectList"
                                                                [value]="item.EsCode">
                                                                {{item.EsName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Address </mat-label>
                                                        <input matInput formControlName="Addr1"
                                                            placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Permanent Address </mat-label>
                                                        <input matInput formControlName="Addr1P"
                                                            placeholder="">
                                                    </mat-form-field>

                                                </div>
                                            </div>

                                            <div class="col-sm-4">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Subject</mat-label>
                                                        <input matInput formControlName="ExSub"
                                                            placeholder="">

                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> </mat-label>
                                                        <input matInput formControlName="Addr2"
                                                            placeholder="">

                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> </mat-label>
                                                        <input matInput formControlName="Addr2P"
                                                            placeholder="">

                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-4">

                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> </mat-label>
                                                        <input matInput formControlName="Addr3"
                                                            placeholder="">

                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> </mat-label>
                                                        <input matInput formControlName="Addr3P"
                                                            placeholder="">

                                                    </mat-form-field>

                                                </div>
                                            </div>

                                            <div class="col-sm-1">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Valid</mat-label>
                                                        <mat-select formControlName="valid" #select104
                                                            class="colorblack">
                                                            <mat-option value="N">No</mat-option>
                                                            <mat-option value="Y">Yes</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> </mat-label>
                                                        <input matInput formControlName="msg"
                                                            placeholder="">

                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Place</mat-label>
                                                        <input matInput formControlName="Place"
                                                            placeholder="Place">

                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Pin Code</mat-label>
                                                        <input matInput formControlName="Pin"
                                                            placeholder="Pin">

                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Permanent Place</mat-label>
                                                        <input matInput formControlName="PlaceP"
                                                            placeholder="PlaceP">

                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">

                                                    <mat-form-field appearance="outline" appearance="outline"
                                                        class="example-full-width">
                                                        <mat-label>Permanent Pin Code </mat-label>
                                                        <input matInput formControlName="PinP"
                                                            placeholder="PinP">

                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <!-- <div class="col-sm-12">
                                                <button type="button" *ngIf="submitbutton" 
                                                    class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
                                                    (click)="addRegFormData()">Submit</button>
                                                 <button type="button"
                                                        class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                        *ngIf="updatebutton" (click)="update()">Update</button> 
                                                </div> -->
                                            <!-- <div class="row col-sm-12">
                                                    <div class="col-sm-12 prpl">
                                                        <button  *ngIf="submitbutton" type="button"(click)="addRegFormData()"
                                                    class="btn btn-primary btn-icon-text floatright mt-1">
                                                    <span style="display: contents; align-items: center;">
                                                         <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 7px;">
                                                          Save
                                                    </span>
                                                    <button type="button" *ngIf="updatebutton"
                                                    class="btn btn-primary btn-icon-text floatright mt-1"
                                                    (click)="update()">
                                                    <span style="display: contents; align-items: center;">
                                                         <img width="20vh" src="../../assets/img/edit.gif" style="margin-right: 5px;">
                                                        Update
                                                    </span>
                                                    </button>
                                                </button>
                                                    </div>
                                                </div> -->
                                            <div class="row col-sm-12">
                                                <div class="col-sm-12 prpl">
                                                    
                                                        <button type="button"  *ngIf="submitbutton && regCreate" (click)="addRegFormData()"
                                                            class="btn size1 btn-primary btn-icon-text floatright mt-1">
                                                            <span style="display: contents; align-items: center;">
                                                                <img width="15vh" src="../../assets/img/save.gif"
                                                                    style="margin-right: 7px;">
                                                                Save
                                                            </span>
                                                        
                                                        </button>
                                                    
                                                        <button *ngIf="deletebutton && regDelete" type="button" class="btn size1 btn-primary btn-icon-text floatright mt-1"
                                                            (click)="delete()">
                                                            <span style="display: contents; align-items: center;">
                                                                <img width="15vh" src="../../assets/img/trash.gif" style="margin-right: 5px;">
                                                                Delete
                                                            </span>
                                                        </button>

                                                        <button *ngIf="updatebutton && regUpdate" type="button" class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                                                            (click)="update()">
                                                            <span style="display: contents; align-items: center;">
                                                                <img width="15vh" src="../../assets/img/edit.gif" style="margin-right: 7px;">
                                                                Update
                                                            </span>
                                                        </button>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                        <hr>
                                        <div *ngIf="Table" class="col-sm-12 pl-0">
                                            <div>
                                                <div class="table-responsive " id="table">
                                                    <table appShortTable class="table table-bordered text-nowrap">
                                                        <thead>
                                                            <tr class="text-left">
                                                                <th class="f600">
                                                                    RgNo
                                                                </th>
                                                                <!-- <th class="f600">
                                                                    Batch
                                                                </th> -->
                                                                <th class="f600">
                                                                    Name
                                                                </th>
                                                                <th class="f600">
                                                                    College
                                                                </th>
                                                                <!-- <th  class="f600">
                                                                    Branch
                                                                </th> -->
                                                                <th class="f600">
                                                                    Gender
                                                                </th>
                                                                <th class="f600">
                                                                    Caste
                                                                </th>
                                                                <th class="f600">
                                                                    Cate
                                                                </th>
                                                                <th class="f600">
                                                                    M
                                                                </th>
                                                                <!-- <th width="5%" class="f600">
                                                                    Exm
                                                                </th>
                                                                <th width="5%" class="f600">
                                                                    Sk
                                                                </th> -->
                                                                <!-- <th width="5%" class="f600">
                                                                    Del
                                                                </th> -->
                                                                <th class="f600">
                                                                    Valid
                                                                </th>
                                                                <th class="f600">
                                                                    Change
                                                                </th>
                                                                <th class="f600">
                                                                    Message
                                                                </th>
                                                                <!-- <th width="8%" class="f600">
                                                                    Mobile
                                                                </th> -->
                                                                <!-- <th>
                                                                    Action
                                                                </th> -->
                                                                
                                                            </tr>
                                                        </thead>
                                                        <tbody class="curs">
                                                            <tr *ngFor="let item of ListOfGrid;"
                                                                (click)="editdata(item)">
                                                                <td>{{item.RgNo}}</td>
                                                                <!-- <td>{{item.Batch}}</td> -->
                                                                <td>{{item.Name}}</td>
                                                                <td>{{item.CgCode}}</td>
                                                                <!-- <td>{{item.StrCode}}</td> -->
                                                                <td>{{item.Sex}}</td>
                                                                <td>{{item.Caste}}</td>
                                                                <td>{{item.Cate}}</td>
                                                                <td>{{item.Medium}}</td>
                                                                <!-- <td></td>
                                                                <td></td>
                                                                <td></td> -->
                                                                <td>{{item.Valid}}</td>
                                                                <td>{{item.Chng}}</td>
                                                                <td>{{item.Mesg}}</td>
                                                                <!-- <td class="text-center">
                                                                    <a class="btn-floating" title="Edit" (click)="editdata(item)">
                                                                        <i class="fa fa-edit"></i>
                                                                    </a>
                                                                </td> -->
                                                                <!-- <td>{{item.Mobile}}</td> -->
                                                                
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>